const Hero = () => {
  return (
    <section data-testid="hero-section" className="min-h-screen flex flex-col justify-center items-center text-center relative overflow-hidden pt-20 pb-32 md:pb-40">
      <div className="absolute inset-0 z-0 bg-primary">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{ backgroundImage: 'url(https://www.transparenttextures.com/patterns/cubes.png)' }}></div>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl relative z-10">
        <div className="mb-12 md:mb-16">
          <img
            src="https://customer-assets.emergentagent.com/job_first-gen-future/artifacts/dzq8u6iz_ChatGPT%20Image%20May%206%2C%202026%20at%2009_33_50%20AM.png"
            alt="Lantern Prep"
            className="h-40 md:h-48 w-auto mx-auto block select-none"
            style={{ mixBlendMode: 'lighten' }}
            draggable={false}
          />
        </div>

        <h1 data-testid="hero-headline" className="text-5xl md:text-7xl font-heading font-bold tracking-tight leading-[1.1] text-primary-foreground mb-8">
          Light today. Lead tomorrow.
        </h1>
        
        <p data-testid="hero-subheadline" className="text-lg md:text-xl leading-relaxed text-primary-foreground/90 max-w-2xl mx-auto mb-6">
          Considered preparation for the SAT, college admissions, and the years that follow.
        </p>

        <p className="text-base text-primary-foreground/80 mb-12 max-w-2xl mx-auto leading-relaxed">
          Lantern Prep serves rising juniors and seniors in St. Petersburg and the greater Tampa Bay area through two pathways into the same cohort.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5">
          <a
            href="/apply"
            data-testid="hero-cta-scholarship"
            className="w-full sm:w-auto inline-block bg-accent text-accent-foreground px-8 py-4 rounded-sm font-medium text-base tracking-wide hover:bg-accent/90 transition-all text-center"
          >
            Apply for a Scholarship Seat
          </a>
          <a
            href="/contact"
            data-testid="hero-cta-consultation"
            className="w-full sm:w-auto inline-block bg-accent text-accent-foreground px-8 py-4 rounded-sm font-medium text-base tracking-wide hover:bg-accent/90 transition-all text-center"
          >
            Request Consultation
          </a>
        </div>

        <p className="text-sm text-accent/90 mt-6 max-w-xl mx-auto leading-relaxed">
          Every engagement contributes directly to scholarship seats in the same cohort.
        </p>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-primary-foreground/40 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-accent rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;